import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    HarvestEventEntityId,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Components
// @ts-ignore
import EntityNameValue from 'components/EntityName';

// Global Selectors
import { makeSelectHarvestEventEntityId } from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    entityId?: HarvestEventEntityId;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventEntityNameValue extends React.PureComponent<Props> {
    render(): string | React.ReactElement | null {
        const { entityId } = this.props;
        if (entityId) {
            return <EntityNameValue entityId={entityId} hideEntityType />;
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityId: makeSelectHarvestEventEntityId()
});

export default connect(mapStateToProps)(HarvestEventEntityNameValue);
